import {
    ProductReviewsContainer as SourcerProductReviewsContainer,
    mapStateToProps,
    mapDispatchToProps
} from 'SourceComponent/ProductReviews/ProductReviews.container';

import { connect } from 'react-redux';
import {PureComponent} from "react";

export class ProductReviewsContainer extends SourcerProductReviewsContainer {

    componentDidMount() {
        const addReview = new URLSearchParams(location.search).get('addReview');
        if(addReview == '1') {
            this._showPopup();
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewsContainer);
